import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-4 items-baseline mb-7 sm:flex-nowrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "shrink-0 text-xl font-bold lg:text-2xl" }, " Независимые рейтинги ", -1)
const _hoisted_3 = { class: "overflow-hidden relative grow" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_6 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "grid gap-10 sm:grid-cols-2 md:grid-cols-3"
}
const _hoisted_8 = { class: "aspect-video block relative w-full" }
const _hoisted_9 = {
  key: 0,
  class: "absolute top-3 right-3 z-10 px-2 text-sm bg-teal-100"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-col p-5 h-full" }
const _hoisted_12 = { class: "block flex-none text-lg font-bold" }
const _hoisted_13 = { class: "hidden flex-1 my-4 lg:block" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "block flex-none pt-4 mt-auto text-right" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "block py-2 px-3 font-bold text-center text-zinc-100 bg-teal-500 rounded shadow lg:inline-block" }, " Читать ")
], -1)

import { computed, onMounted, ref } from 'vue';
import { default as axios } from 'axios';
import { Product } from '../types/Product';
import { ArrowCircleRightIcon, ArrowCircleLeftIcon } from '@heroicons/vue/outline';
import { useElementBounding, useElementSize, useMouse, useRafFn, useScroll, useWindowSize } from '@vueuse/core';
import { Pausable } from '@vueuse/shared';


export default /*#__PURE__*/_defineComponent({
  props: {
    news: null
  },
  setup(__props: any) {

const props = __props as {
  news: {
    title: string
    slug: string
    excerpt: string
    id: number
    image?: string
    category?: Product['category']
  }[] | null
}



const isTouchDevice = () => {
  let isMobile = false;
  if (navigator !== undefined && navigator !== null) {
    if ('maxTouchPoints' in navigator) {
      isMobile = navigator.maxTouchPoints > 0;
    } else if ('msMaxTouchPoints' in navigator) {
      const msNavigator = navigator as typeof navigator & {msMaxTouchPoints: number};
      
      isMobile = msNavigator.msMaxTouchPoints > 0;
    
    } else {
      const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
      if (mQ && mQ.media === '(pointer:coarse)') {
        isMobile = !!mQ.matches;
      } else if ('orientation' in window) {
        isMobile = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        const UA = navigator!.userAgent;
        isMobile = (
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
        );
      }
    }
  }
  
  return isMobile;
};

const selectedCategory = ref<Product['category'] | null>(null);
const categories = ref<Product['category'][]>([]);

const scrollRight = ref<Pausable>();
const scrollLeft = ref<Pausable>();

onMounted(async () => {
  categories.value = (await axios.get('/api/news-types')).data.data;
  
  scrollRight.value = useRafFn(() => {
    // if (tagContainerScroll.arrivedState.right) {
    //   return scrollRight.value.pause();
    // }
    
    tagContainer.value.scrollTo({
      left: tagContainerScroll.x.value + 4,
    });
  }, {
    immediate: false,
  });
  
  scrollLeft.value = useRafFn(() => {
    if (tagContainerScroll.x.value <= 0) {
      return scrollLeft.value.pause();
    }
    
    tagContainer.value.scrollTo({
      left: tagContainerScroll.x.value - 4,
    });
  }, {
    immediate: false,
  });
});

const filteredNews = computed(() => {
  if (!selectedCategory.value) {
    return props.news;
  }
  
  return props.news.filter((item) => {
    return item.category.id === selectedCategory.value.id;
  });
});

const tagClasses = (itemId) => {
  let activeClasses = [];
  
  if (selectedCategory.value === itemId) {
    activeClasses = ['bg-teal-500', 'text-white'];
  } else {
    activeClasses = ['text-zinc-400'];
  }
  
  return [
    'font-bold',
    'px-2',
    'whitespace-nowrap',
    'py-0.5',
    'rounded',
    ...activeClasses,
  ];
};

const selectCategory = (value) => {
  selectedCategory.value = value;
};



const tagContainer = ref<HTMLElement | null>(null);
const tagContainerScroll = useScroll(tagContainer);

const startScrollRight = () => {
  if (tagContainer.value && !isTouchDevice() && scrollLeft.value && scrollRight.value) {
    scrollLeft.value.pause();
    scrollRight.value.resume();
  }
};

// const stopScrollRight = () => {
//   if (tagContainer.value) {
//     scrollRight.value.pause();
//     scrollLeft.value.pause();
//   }
// };

const startScrollLeft = () => {
  if (tagContainer.value && !isTouchDevice() && scrollLeft.value && scrollRight.value) {
    scrollRight.value.pause();
    scrollLeft.value.resume();
  }
};

// const stopScrollLeft = () => {
//   if (tagContainer.value) {
//     scrollLeft.value.pause();
//     scrollRight.value.pause();
//   }
// };

const stopScrollAll = () => {
  if (tagContainer.value && !isTouchDevice() && scrollLeft.value && scrollRight.value) {
    scrollLeft.value.pause();
    scrollRight.value.pause();
  }
};

const tagContainerInner = ref<HTMLElement | null>(null);
const tagContainerSize = useElementSize(tagContainer);
const tagContainerInnerSize = useElementSize(tagContainerInner);

const isOverflowing = computed(() => {
  if (tagContainer.value) {
    return tagContainerSize.width.value < tagContainerInnerSize.width.value;
  }
  
  return false;
});


const selectPrevTag = () => {
  const currentIndex = categories.value.indexOf(selectedCategory.value);
  const prevIndex = currentIndex > 0 ? currentIndex - 1 : null;
  
  if (prevIndex === null) {
    selectCategory(null);
  } else {
    const prevCategory = categories.value[prevIndex];
    selectCategory(prevCategory);
  }
  
  if (tagContainerInner.value) {
    const el = tagContainerInner.value.children.item(currentIndex);
  
    if (el) {
      el.scrollIntoView({behavior: 'smooth'});
    }
  }
};

const selectNextTag = () => {
  const currentIndex = categories.value.indexOf(selectedCategory.value);
  const nextIndex = currentIndex < (categories.value.length - 1) ? (currentIndex + 1) : (categories.value.length - 1);
  
  const nextCategory = categories.value[nextIndex];
  selectCategory(nextCategory);
  
  if (tagContainerInner.value) {
    const el = tagContainerInner.value.children.item(currentIndex + 2);
    
    if (el) {
      el.scrollIntoView(true);
    }
  }
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          ref_key: "tagContainer",
          ref: tagContainer,
          class: _normalizeClass({'overflow-auto': isTouchDevice(), 'overflow-hidden' : !isTouchDevice()}),
          onMouseenter: stopScrollAll,
          onMousedown: stopScrollAll
        }, [
          _createElementVNode("div", {
            ref_key: "tagContainerInner",
            ref: tagContainerInner,
            class: "inline-flex gap-x-6 gap-y-2 py-4"
          }, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass([...tagClasses(null)]),
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (selectCategory(null)), ["prevent"]))
            }, " Показать все ", 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
              return (_openBlock(), _createElementBlock("a", {
                key: category.id,
                class: _normalizeClass([...tagClasses(category)]),
                href: "#",
                onClick: _withModifiers(($event: any) => (selectCategory(category)), ["prevent"])
              }, _toDisplayString(category.title), 11, _hoisted_4))
            }), 128))
          ], 512)
        ], 34),
        (!_unref(tagContainerScroll).arrivedState.left && _unref(isOverflowing))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              href: "#",
              class: "absolute -top-1 -left-px py-5 pr-8 text-zinc-400 hover:text-zinc-600 bg-gradient-to-r from-white via-white cursor-pointer user-select-none",
              onMouseenter: _withModifiers(startScrollLeft, ["prevent"]),
              onMouseleave: _withModifiers(stopScrollAll, ["prevent"]),
              onClick: _withModifiers(selectPrevTag, ["prevent"]),
              onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_unref(ArrowCircleLeftIcon), { class: "w-7 h-7" })
            ], 40, _hoisted_5))
          : _createCommentVNode("", true),
        (!_unref(tagContainerScroll).arrivedState.right && _unref(isOverflowing))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              href: "#",
              class: "absolute -top-1 -right-px py-5 pl-8 text-zinc-400 hover:text-zinc-600 bg-gradient-to-l from-white via-white cursor-pointer user-select-none",
              onMouseenter: _withModifiers(startScrollRight, ["prevent"]),
              onMouseleave: _withModifiers(stopScrollAll, ["prevent"]),
              onClick: _withModifiers(selectNextTag, ["prevent"]),
              onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createVNode(_unref(ArrowCircleRightIcon), { class: "w-7 h-7" })
            ], 40, _hoisted_6))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(filteredNews))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredNews), (newsItem) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: newsItem.id,
              to: { name: 'page', params: { slug: newsItem.slug } },
              class: "flex flex-col bg-zinc-100 shadow-2xl transition-all hover:scale-105"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, [
                  (newsItem.category)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(newsItem.category.title), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: '/storage/' + newsItem.image
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("span", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(newsItem.title), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(newsItem.excerpt), 1),
                  _hoisted_14
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})